import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Container
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";

const useStyles = makeStyles(() => ({
  root: {
    margin: 15
  }
}));

export default function PaperSheet() {
  const classes = useStyles();

  return (
    <ExpansionPanel className={classes.root}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1">通知</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Container>
          <Skeleton />
          <Skeleton width="60%" />
        </Container>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}
